import React from 'react';
import styled from 'styled-components';
import { Text, theme } from 'components';

const Section: React.FC<{ id?: string; title: string; headingIcon?: any }> = ({
  id,
  title,
  children,
  headingIcon,
}) => (
  <SectionContainer id={id}>
    <Header>
      <HeaderText strong>{title}</HeaderText>
      <p>{headingIcon}</p>
    </Header>
    {children}
  </SectionContainer>
);

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-top: 1px solid ${theme.gray4};
  padding: 15px 0px;
`;

const HeaderText = styled(Text)`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 16px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default Section;
